export const HelpLinkValidation = (formData) => {
    const errors = {};
    debugger;
    // Validate each field
    if (!formData.Link.trim() && formData.Link.trim()==="") {
      errors.Link = 'This field is required';
    }
    return errors;
  };
  
  